module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingUp-83b8906d4e66a6dcab6abf0974076ceb.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/apprenticePointingUp.png
// module id = 403
// module chunks = 2